/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Workstation
 */
export interface Workstation {
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    readonly displayName: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Workstation
     */
    report?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    hostname: string;
    /**
     * 
     * @type {Date}
     * @memberof Workstation
     */
    lastSeen?: Date | null;
}

export function WorkstationFromJSON(json: any): Workstation {
    return WorkstationFromJSONTyped(json, false);
}

export function WorkstationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workstation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['display_name'],
        'report': !exists(json, 'report') ? undefined : json['report'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hostname': json['hostname'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
    };
}

export function WorkstationToJSON(value?: Workstation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'report': value.report,
        'name': value.name,
        'hostname': value.hostname,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen === null ? null : value.lastSeen.toISOString()),
    };
}


